import React from 'react'
import { get } from 'lodash'

import { createSnackbar } from 'utils/createSnackbar'

import instance from 'api/v1'
import { useAuth } from 'hooks/useAuth'

export function useFetchNews () {
  // @ts-ignore
  const { user } = useAuth()
  const apiInstance = instance(user)

  return React.useCallback((news: any, setNews: any) => {
    const page = get(news, 'page', 1)

    const fetch = async () => {
      await apiInstance.get(`/news`, {
        params: {
          page,
        },
      })
        .then(({ data }) => {
          setNews({
            ...news,
            news: data.data,
            loading: false,
            pagination: data.meta,
          })
        })
        .catch((error) => {
          setNews({
            ...news,
            loading: false,
            error: true,
          })
          console.error(error)
          if (error.message) createSnackbar(error.message)
          else if (error.response) createSnackbar(error.response.data.message)
          else createSnackbar('Something went wrong')
        })
    }
    fetch()
  }, [])
}
